"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscribeButtonError = exports.SUBSCRIBE_BUTTON_ERROR_QUERY = void 0;
var client_1 = require("@apollo/client");
exports.SUBSCRIBE_BUTTON_ERROR_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SubscribeButtonErrorData {\n    identity {\n      id\n      email\n    }\n  }\n"], ["\n  query SubscribeButtonErrorData {\n    identity {\n      id\n      email\n    }\n  }\n"])));
// The maximum length of the local part of an email address (the part before the @ symbol)
// This limitation comes from RFC 5321, which defines the SMTP protocol
// https://datatracker.ietf.org/doc/html/rfc5321#section-4.5.3.1.1
var MAX_EMAIL_LOCAL_PART_LENGTH = 64;
var getIsEmailLocalPartTooLong = function (email) {
    var _a;
    if (!email) {
        return false;
    }
    var emailLocalPart = ((_a = email.split("@")) !== null && _a !== void 0 ? _a : [])[0];
    return (!!emailLocalPart && emailLocalPart.length > MAX_EMAIL_LOCAL_PART_LENGTH);
};
var useSubscribeButtonError = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.skip, skip = _d === void 0 ? false : _d;
    var _e = (0, client_1.useQuery)(exports.SUBSCRIBE_BUTTON_ERROR_QUERY, {
        skip: skip,
    }), data = _e.data, loading = _e.loading, error = _e.error;
    var errorType;
    if (getIsEmailLocalPartTooLong((_b = data === null || data === void 0 ? void 0 : data.identity) === null || _b === void 0 ? void 0 : _b.email)) {
        errorType = "EMAIL_LOCAL_PART_TOO_LONG";
    }
    else if (error) {
        errorType = "OTHER";
    }
    var hasError = !!errorType;
    return { loading: loading, errorType: errorType, hasError: hasError };
};
exports.useSubscribeButtonError = useSubscribeButtonError;
var templateObject_1;
